import React from "react";
import "./BlogHero.css";
import Navbar from "../Header/Navbar";
import { Link } from "react-router-dom";

const BlogHero = () => {
  return (
    <>
      <Navbar />

      {/* BLOG HERO */}
      <section className="blog-mini-hero">
        <div className="blog-mini-container">
          <h1 className="blog-mini-title">Blogs</h1>

          <p className="blog-mini-breadcrumb">
            <Link to="/" className="blog-mini-link">Home</Link>
            <span>-</span>
          
          
            <Link to="/blogs" className="blog-mini-link">Blogs</Link>
          </p>
        </div>
      </section>
    </>
  );
};

export default BlogHero;
